import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';
import { normalizeShipmentCategory } from './normalize';

export const fetchShipmentCategory = createProvider(api.fetchShipmentCategory)
  .andThen((res) => normalizeShipmentCategory(res))
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      console.warn('Fetch list aborted');
    } else {
      console.error('Fetch list was failed:', error);
    }
    throw error;
  });
